import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  Rarity,
  SeasonEligibility,
} from '@sorare/core/src/__generated__/globalTypes';
import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { seasonEligibilityMessages } from '@sorare/core/src/lib/glossary';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(Horizontal).attrs({ gap: 2 })`
  padding: var(--double-unit) var(--intermediate-unit);
  border-bottom: 1px solid var(--c-nd-50);
  @media (${tabletAndAbove}) {
    padding: var(--triple-unit);
  }
`;

type Props = {
  rarity: Rarity;
  filterableRarities: Rarity[];
  onRarityChange: (rarity: Rarity) => void;
  seasonEligibility?: SeasonEligibility;
  onSeasonEligibilityChange: (seasonEligibility: SeasonEligibility) => void;
};

const seasonEligibilityOptions = [
  SeasonEligibility.IN_SEASON,
  SeasonEligibility.CLASSIC,
];

export const TransactionsFilters = ({
  onRarityChange,
  rarity,
  filterableRarities,
  seasonEligibility,
  onSeasonEligibilityChange,
}: Props) => {
  const { formatMessage } = useIntlContext();
  return (
    <Wrapper>
      {seasonEligibility && (
        <FilterInDropdown
          buttonLabel={
            <FormattedMessage
              {...seasonEligibilityMessages[seasonEligibility]}
            />
          }
        >
          {({ closeDropdown }) => (
            <RadioGroup
              modalSelect
              options={[...seasonEligibilityOptions].map(option => ({
                label: formatMessage(seasonEligibilityMessages[option]),
                value: option,
              }))}
              initiallySelectedValue={seasonEligibility}
              name="player-transactions-tab-season-eligibility"
              onChange={value => {
                onSeasonEligibilityChange(value);
                closeDropdown();
              }}
            />
          )}
        </FilterInDropdown>
      )}
      <FilterInDropdown
        buttonLabel={<FormattedMessage {...scarcityMessages[rarity]} />}
      >
        {({ closeDropdown }) => (
          <RadioGroup
            modalSelect
            options={[...filterableRarities].map(filterableRarity => ({
              label: formatMessage(scarcityMessages[filterableRarity]),
              value: filterableRarity,
            }))}
            initiallySelectedValue={rarity}
            name="player-transactions-tab-rarity"
            onChange={value => {
              onRarityChange(value);
              closeDropdown();
            }}
          />
        )}
      </FilterInDropdown>
    </Wrapper>
  );
};
